import { createAsyncThunk } from '@reduxjs/toolkit';
import { dataSourcesService } from '../../services';

const getDataSourcesList = createAsyncThunk(
    'dataSources/getDataSourcesList',
    async (payload, ThunkAPI) => {
        try {
            const response = await dataSourcesService.getDataSourcesList(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDataSourceById = createAsyncThunk(
    'dataSources/getDataSourceById',
    async (payload, ThunkAPI) => {
        try {
            const response = await dataSourcesService.getDataSourceById(payload.companyId, payload.dataSourceId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const createDataSources = createAsyncThunk(
    'dataSources/createDataSources',
    async (payload, ThunkAPI) => {
        try {
            const response = await dataSourcesService.createDataSources(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateDataSourceById = createAsyncThunk(
    'dataSources/updateDataSourceById',
    async (payload, ThunkAPI) => {
        try {
            const response = await dataSourcesService.updateDataSourceById(payload.companyId, payload.dataSourceId, payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteDataSources = createAsyncThunk(
    'dataSources/deleteDataSources',
    async (payload, ThunkAPI) => {
        try {
            const response = await dataSourcesService.deleteDataSources(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const dataSourceHistoryByPage = createAsyncThunk(
    'dataSources/dataSourceHistoryByPage',
    async (payload, ThunkAPI) => {
        try {
            const response = await dataSourcesService.dataSourceHistoryByPage(payload.companyId, payload.page);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const uploadDataSourceFile = createAsyncThunk(
    'dataSources/uploadDataSourceFile',
    async (payload, ThunkAPI) => {
        try {
            const response = await dataSourcesService.uploadDataSourceFile(payload.companyId, payload.dataSourceId, payload.file);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

export {
    getDataSourcesList,
    getDataSourceById,
    createDataSources,
    updateDataSourceById,
    deleteDataSources,
    dataSourceHistoryByPage,
    uploadDataSourceFile
};
